import { TitleButton } from '@/common/buttons/TitleButton';
import { ActionDialog } from '@/common/dialog/ActionDialog';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { AbvOverUnderScenActionSelect } from './AbvOverUnderScenActionSelect';
import { AbvOverUnderScenForm } from './AbvOverUnderScenForm';
import { AbvChbkPipeOverUnderPerspective } from './chbkpipeoverunder/AbvChbkPipeOverUnderPerspective';
import { AbvMcdLiabPerspective } from './mcdLiab/AbvMcdLiabPerspective';
import { AbvOverUnderPerspective } from './overUnder/AbvOverUnderPerspective';
import { AbvPbmLiabPerspective } from './pbmLiab/AbvPbmLiabPerspective';
import { AbvRbtPipeOverUnderPerspective } from './rbtpipeoverunder/AbvRbtPipeOverUnderPerspective';

export const AbvOverUnderScenDetail = () => {

  const { entityObj } = useEntityMgr();
  const { openDialog } = useDialog();

  const augButtons = (buttons) => {

    if (entityObj.status !== 'APPROVED') {
      buttons.push(
        <AbvOverUnderScenActionSelect entityId={entityObj.id}></AbvOverUnderScenActionSelect>
      );
    }

    buttons.push(
      <TitleButton toolTip={'Duplicate this Scenario'} icon={fas.faCopy} dataTestId="bulk-adj" onClick={() => actionDialog('Duplicate Scenario', 'OVER_UNDER_SCEN_DUP_ACTION_PLUGIN')}></TitleButton>
    );
  }

  const actionDialog = (title, pluginCode) => {
    openDialog(ActionDialog, {
      data:
      {
        title,
        pluginCode,
        entity: 'OVER_UNDER_SCEN',
        entityId: entityObj.id
      }
    });
  }

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <AbvOverUnderScenForm /> },
    { id: 'pbmLiabTab', label: 'PBM Liability', content: <AbvPbmLiabPerspective overUnderScenId={entityObj.id} /> },
    { id: 'mcdLiabTab', label: 'Medicaid Liability', content: <AbvMcdLiabPerspective overUnderScenId={entityObj.id} /> },
    { id: 'overUnderTab', label: 'Base Over/(Under)', content: <AbvOverUnderPerspective overUnderScenId={entityObj.id} /> },
    { id: 'rbtPipeOverUnderTab', label: 'Rebate Pipeline Over/(Under)', content: <AbvRbtPipeOverUnderPerspective overUnderScenId={entityObj.id} /> },
    { id: 'chbkPipeOverUnderTab', label: 'Chargeback Pipeline Over/(Under)', content: <AbvChbkPipeOverUnderPerspective overUnderScenId={entityObj.id} /> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="OVER_UNDER_SCEN" parentEntityId={entityObj.id} /> }
  ]

  return (
    <EntityDetail
      tabSpecs={tabSpecs}
      augButtons={augButtons}
    />
  )
}